import { Typography } from '@montugroup/design-system';
import { Accordion } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { StyledAccordionDetails, StyledAccordionSummary } from './PrescriptionAccordion.styles';

import type { Prescription, ScriptMetadata } from './common';
import { getProductName } from './common';
import { PrescriptionDetails } from './PrescriptionDetails';

export interface IPrescriptionAccordion {
  prescription: Prescription;
  prescriptionMetaData: ScriptMetadata;
}

export function PrescriptionAccordion({ prescription, prescriptionMetaData }: IPrescriptionAccordion) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      disableGutters
      expanded={expanded}
      elevation={0}
      onChange={(_event, isExpanded) => setExpanded(isExpanded)}
      slotProps={{
        transition: { unmountOnExit: true },
      }}
      data-testid="prescription-accordion"
    >
      <StyledAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="prescription-content"
        id="prescription-content"
      >
        <Typography>{getProductName(prescription)}</Typography>
      </StyledAccordionSummary>

      <StyledAccordionDetails>
        <PrescriptionDetails prescription={prescription} prescriptionMetaData={prescriptionMetaData} />
      </StyledAccordionDetails>
    </Accordion>
  );
}

export default PrescriptionAccordion;
